import {
	getGoodsAll,
	goodsGrounding
} from '@/api/goods';

import Pagination from '@/components/Pagination';

export default {
	name: 'goods',
	data() {
		return {
			orderObj: { //商品列表
				list: [],
				total: 0,
				listLoading: false,
			},
			form: {
				pageNum: 1,
				pageSize: 10,
			},
			attachPath: '/ssycfile'
		}
	},
	components: {
		Pagination
	},
	beforeCreate() {
	},
	created() {
		this.getOrderPage()
	},
	filters: {
		statusFilter(type) { //充值渠道
			return {
				0:'上架',
				1:'下架'
			}[type]
		},
	},
	methods: {
		//获取订单列表
		getOrderPage() {
			
			this.orderObj.listLoading = true;
			console.log(this.form)
			//获取订单列表
			getGoodsAll(this.form).then(res => {
				this.orderObj.list = res.data.list;
				this.orderObj.total = res.data.total;
				this.orderObj.listLoading = false;

			})
		},
		
		//跳转详情
		gotoDetail(id) {
			this.$router.push('goodsEdit?id='+id)
		},

		//上下架状态
		changeStatus(row, index) {
			console.log(row)
			let status = row.status == 1 ? 0 : 1
			goodsGrounding(row).then(res => {
				this.orderObj.list[index].status = status
			})
			
		},
	}
}
